import { mnoStatusFilterAtom } from 'atoms/filters/sim';
import { MultiSelect } from 'common/components/Inputs/MultiSelect/MultiSelect';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import {
  MNOStatusFilter,
  MNO_STATUS_FILTER,
  getFilterLabelBaseOnMnoStatus,
} from 'src/common/components/Sim/constants/mnoStatus';

export const MNOStatusInput = () => {
  const { t } = useTranslation();
  const [mnoStatus, setMNOStatus] = useAtom(mnoStatusFilterAtom);

  const MNOStatusOptions = [
    {
      label: getFilterLabelBaseOnMnoStatus(MNO_STATUS_FILTER.BLANK, t),
      value: MNO_STATUS_FILTER.BLANK,
    },
    {
      label: getFilterLabelBaseOnMnoStatus(MNO_STATUS_FILTER.ACTIVE, t),
      value: MNO_STATUS_FILTER.ACTIVE,
    },
    {
      label: getFilterLabelBaseOnMnoStatus(MNO_STATUS_FILTER.ACTIVEREADY, t),
      value: MNO_STATUS_FILTER.ACTIVEREADY,
    },
    {
      label: getFilterLabelBaseOnMnoStatus(MNO_STATUS_FILTER.DEACTIVATED, t),
      value: MNO_STATUS_FILTER.DEACTIVATED,
    },
    {
      label: getFilterLabelBaseOnMnoStatus(MNO_STATUS_FILTER.TERMINATED, t),
      value: MNO_STATUS_FILTER.TERMINATED,
    },
    {
      label: getFilterLabelBaseOnMnoStatus(MNO_STATUS_FILTER.INVENTORY, t),
      value: MNO_STATUS_FILTER.INVENTORY,
    },
    {
      label: getFilterLabelBaseOnMnoStatus(MNO_STATUS_FILTER.TESTREADY, t),
      value: MNO_STATUS_FILTER.TESTREADY,
    },
    {
      label: getFilterLabelBaseOnMnoStatus(MNO_STATUS_FILTER.UNRECOGNIZED, t),
      value: MNO_STATUS_FILTER.UNRECOGNIZED,
    },
  ];

  return (
    <MultiSelect<MNOStatusFilter>
      data-testid={'mno-status-multiselect'}
      name="mnoStatus"
      value={mnoStatus}
      onChange={(value) => {
        setMNOStatus(value);
      }}
      showSelectAll={true}
      options={MNOStatusOptions}
      placeholder={t('simInventory.mnoFilterStatusPlaceholder')}
    />
  );
};
